module.exports = __webpack_public_path__ + "img/Porto Apartment - 80 of 85.500cf736.jpeg";